<script lang="ts" setup>
import { SancareOcticon } from '@sancare/typescript-commons'
import { PropType } from 'vue'

import { StayNotificationEnum, StayStatus } from '@/store/modules/stay/types'

defineProps({
  displayed: { type: Boolean, required: true },
  staySeen: { type: Object as PropType<StayStatus>, required: true }
})

const StayNotificationStyleClass: { [key in StayNotificationEnum]: string } = {
  [StayNotificationEnum.NONE]: '',
  [StayNotificationEnum.NOT_READ]: '',
  [StayNotificationEnum.SOFT]: 'soft-notification-icon-cell',
  [StayNotificationEnum.HARD]: 'hard-notification-icon-cell'
}

const StayNotificationIcon: {
  [key in StayNotificationEnum]: { name: string, width: number, height: number }
} = {
  [StayNotificationEnum.NONE]: { name: 'dot-fill', width: 4, height: 11 },
  [StayNotificationEnum.NOT_READ]: { name: 'dot-fill', width: 8, height: 13 },
  [StayNotificationEnum.SOFT]: { name: 'dot-fill', width: 8, height: 13 },
  [StayNotificationEnum.HARD]: { name: 'bell-fill', width: 14, height: 14 }
}

</script>

<template>
  <td
    v-if="displayed"
    :class="`column-icon ${StayNotificationStyleClass[staySeen.notification]}`"
  >
    <sancare-octicon
      :name="StayNotificationIcon[staySeen.notification].name"
      :width="StayNotificationIcon[staySeen.notification].width"
      :height="StayNotificationIcon[staySeen.notification].height"
    />
  </td>
</template>
